import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";

import { useStyles } from "../../../../Components/CSS/UserDetailStyle.css";
import SyllabusIcon from "../../../../Assets/Logo/SyllabusIcon.svg";
import { connect } from "react-redux";
import { publicImageUrl } from "../../../../Config/publicImageUrl";
import PdfReader from "../../../../Components/PDFReader/PdfReader";

class SyllabusCards extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subject: "",
      pdfStatus: false,
      fileUrl: "",
      title: "",
    };
  }

  handlePdfStatus = (subject, fileUrl, title) => {
    this.setState({ pdfStatus: true, subject, fileUrl, title });
  };
  handleCancelPdfStatus = () => {
    this.setState({ pdfStatus: false });
  };

  render() {
    const { classes, cardData } = this.props;
    return (
      <div>
        <div style={{ fontSize: 20, fontWeight: "bold" }}>
          {this.props.cardType}
        </div>
        {this.state.pdfStatus ? (
          <div>
            <ListItem>
              <b>Subject:</b> {this.state.subject}
            </ListItem>
            <ListItem>
              <b>Title:</b>
              {this.state.title}
            </ListItem>
            <PdfReader
              fileUrl={this.state.fileUrl}
              title={this.state.title}
              handleCancelPdfStatus={this.handleCancelPdfStatus}
            />
          </div>
        ) : cardData.length !== 0 ? (
          <Grid container spacing={3}>
            {cardData.map((data, index) => (
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4} key={index}>
                <Paper className={classes.paper}>
                  {this.props.role === "Teacher" && (
                    <ListItem>
                      <div style={{ flexGrow: 1 }}>Class: </div>
                      <div>{data.studentClass}</div>
                    </ListItem>
                  )}
                  <ListItem>
                    <b>{data.subject}</b>
                  </ListItem>
                  {data.files.map((file, index) => (
                    <Tooltip
                      key={index}
                      arrow
                      title={`${data.fileCategory}-${index + 1}`}
                      className={classes.tooltip}
                      onClick={() =>
                        this.handlePdfStatus(
                          data.subject,
                          `${publicImageUrl}/${file}`,
                          `${data.fileCategory}-${index + 1}`
                        )
                      }
                    >
                      <img
                        src={SyllabusIcon}
                        alt="Syllabus"
                        style={{ width: 80, height: 80 }}
                      />
                    </Tooltip>
                  ))}
                </Paper>
              </Grid>
            ))}
          </Grid>
        ) : (
          <div>No any files has been uploaded yet</div>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    userId: state.UserReducer.userId,
    userToken: state.UserReducer.userToken,
    userRefreshToken: state.UserReducer.userRefreshToken,
    role: state.UserReducer.role,
    isUser: state.UserReducer.isUser,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(SyllabusCards));
